import script from "./editModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./editModal.vue?vue&type=script&setup=true&lang=ts"

import "./editModal.vue?vue&type=style&index=0&id=568d5a40&lang=scss"

const __exports__ = script;

export default __exports__